import { getCookie } from '../helpers/cookies';

const initialState = {
    auth: getCookie('auth')
        ? JSON.parse(getCookie('auth'))
        : {
              token: null,
              isLogin: false,
              email: null,
              nickname: null,
              id: null,
              expireDay: null,
              password: null
          },
    license: {
        active: getCookie('activeLicense')
            ? JSON.parse(getCookie('activeLicense'))
            : {},
        all: []
    },
    tickets: {
        all: [],
        count: 0,
        notAnsweredCount: 0,
        loading: true,
    },
    notifications: [],
    stats: {}
};

export default initialState;
